import { IInitAction } from './init'

// Action types
export enum types {
  ROUTER_PUSH = 'ROUTER_PUSH',
  ROUTER_CLEAR = 'ROUTER.CLEAR',
}

export interface IRouterPushAction {
  type: types.ROUTER_PUSH
  pathToRedirect: string
}

export interface IRouterClearAction {
  type: types.ROUTER_CLEAR
}

export type RouterActionsType =
  | IRouterPushAction
  | IRouterClearAction
  | IInitAction

// Reducer types
export interface IRouter {
  pathToRedirect?: string
}

// Match params types
export interface IGroupParam {
  groupId: string
}

export interface IPackParam {
  packId: string
}
